import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Crumb } from "@repoflow/components/breadcrumb";
import * as Section from "@repoflow/components/section";
import SitePublicSchema from "@common/schema/site/public";
import { TEMPLATE_LABELS } from "../kinds";
import * as EditRoute from "./edit";

// ONE TEMPLATE, by kind. It has no screen of its own beyond the editor: a
// template is markup, and markup is read in the editor beside its preview or
// not at all — the same argument a section's View screen makes for showing a
// composed preview rather than the fields. So `/template/post` is the editor.
const LocalProvider = ({
  match: {
    params,
    params: { kind },
  },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/${kind}`;
  const basepath = `${parentBasepath}/:kind`;

  return (
    <Section.Provider
      key={kind}
      schema={SitePublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <Switch>
          <Route path={`${basepath}/edit`} component={EditRoute.Content} />
          <Redirect to={`${base}/edit`} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { kind } }) => (
        <>
          <Crumb to={`${base}/edit`} label={TEMPLATE_LABELS[kind] || kind} />
          <Switch>
            <Route path={`${basepath}/edit`} component={EditRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => null;
